import moment from 'moment';
import { find } from 'lodash';
import countryCodes from 'country-codes-list';
import qs from 'qs';

const defaultOptions = { digits: 2, float: true };

export const localeFormatCurrency = ({ value, minDigits = 0, maxDigits = 2, compact = false }) => {

  return parseFloat(value).toLocaleString(/*navigator.languages*/ 'en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
    // roundingPriority: 'morePrecision',
    ...compact && { notation: 'compact' , compactDisplay: 'short' }
  });
};

export const localeFormatNew = ({ value, minDigits = 0, maxDigits = 2, compact = false }) => {

  return parseFloat(value).toLocaleString(/*navigator.languages*/ 'en-US', {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
    // roundingPriority: 'morePrecision'
    ...compact && { notation: 'compact' , compactDisplay: 'short' }
  });
};

export const localeFormat = (value, options) => {
  const newOptions = { ...defaultOptions, ...options };
  const { digits, float } = newOptions;

  let newValue = value;
  if (float) newValue = parseFloat(value);

  newValue = newValue.toLocaleString(navigator.languages || 'en-US', float ? { minimumFractionDigits: digits, maximumFractionDigits: digits } : {});

  return newValue;
};

export const isEmptyValue = value => {
  if (value === null) return true;
  else return value === undefined;
};

export const getCountryCodes = () => {
  const codes = countryCodes.customList('countryCode', '{countryNameEn}');
  const mappedCodes = Object.keys(codes).map(key => ({ key, value: codes[key] }));

  return mappedCodes;
};

export const getCountryByCode = code => {
  const codes = countryCodes.customList('countryCode', '{countryNameEn}');

  return codes[code];
};

export const getCodeByCountry = country => {
  const codes = countryCodes.customList('countryNameEn', '{countryCode}');

  return codes[country === 'United States' ? 'United States of America' : country];
};

export const getCountryCallingCodes = () => {
  const callingCodes = countryCodes.customList('countryCode', '+{countryCallingCode} {countryNameEn}');
  const mappedCallingCodes = Object.keys(callingCodes).map(key => ({ key, value: callingCodes[key] }));

  return mappedCallingCodes;
};

export const getCallingCodeByCode = code => {
  const callingCodes = countryCodes.customList('countryCode', '+{countryCallingCode}');
  return callingCodes[code || 'US'];
};

export const dataURIToBlob = dataURI => {
  const splitDataURI = dataURI.split(',');
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1] ? splitDataURI[0].split(':')[1].split(';')[0] : '';

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++)
    ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
};

export const numberWithCommas = (value, noDigits) => {
  const num = typeof value === 'string' ? Number(value) : value;

  const val = noDigits ? num.toString() : num.toFixed(2).toString();

  return val.split('.').map((v, i) => i !==0 ? v : v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')).join('.');
};

export const formatHistogramData = (date_histogram, dateFilter, stats) => {
  const current_histogram = date_histogram.map(item => ({ key: item.name || item.key, [stats[0]]: item[stats[0]], [stats[1]]: item[stats[1]] }));

  let valuesData = [];
  let start = moment(dateFilter.since);
  let end = moment(dateFilter.until);

  while (start <= end) {
    const date = moment(start).format('MMM D, \'YY');
    const obj = find(current_histogram, x => x.key === date);
    if (obj) {
      valuesData.push(obj);
    } else {
      valuesData.push({ key: moment(start).format('MMM D, \'YY'), [stats[0]]: 0, [stats[1]]: 0 });
    }
    start = moment(start).add(1, 'days');
  }

  return valuesData;
};

export const convertJSONToFormData = data => {
  const flat = qs.stringify(data, { allowDots: true, encode: false });

  const formData = new FormData();
  flat.split('&').forEach(pair => {
    const [key, value] = pair.split('=');
    formData.append(key.replace('.', ''), value);
  });

  return formData;
};